import { useHistory } from 'react-router-dom';
import { useMutation } from "@apollo/client";
import { successNotification } from "../../../../result";



const useMutationPackageDelete = (mutation) => {

  const history = useHistory();

  const [ _setMutationPackageDelete,
    { loading } ] = useMutation(mutation,
        {
          update(_, { data }) {

            const {
              packageDelete: {
                label,
                message
              }
            } = data;

            history.push(`/packages/`);

            successNotification({
              title: label.toUpperCase(),
              description: message
            });
          },
        });

  return {
    _setMutationPackageDelete,
    loadingPackageDelete: loading,
  }
};

export default useMutationPackageDelete;